import { render, staticRenderFns } from "./Entities.vue?vue&type=template&id=64aacfe3&"
import script from "./Entities.vue?vue&type=script&lang=js&"
export * from "./Entities.vue?vue&type=script&lang=js&"
import style0 from "./Entities.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64aacfe3')) {
      api.createRecord('64aacfe3', component.options)
    } else {
      api.reload('64aacfe3', component.options)
    }
    module.hot.accept("./Entities.vue?vue&type=template&id=64aacfe3&", function () {
      api.rerender('64aacfe3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/aduanas/management/entities/views/Entities.vue"
export default component.exports